// used in our filter functions to pause calls when we are typing in the search bar
export const DEBOUNCE_TIMEOUT = 800;
export const MIN_SEARCH_TERM_LENGTH = 3;

export const DEFAULT_PAGINATION_SIZE = 25;
export const DEFAULT_PAGINATION_SCROLL_LIMIT = 0.6;

export const DEFAULT_NOTIFICATION_OVERFLOW = 9;

// locking to 2 years since Stripe arbitrarily sets cancelation dates ~ 3 years from card creation

export const COMMENT_FROM_CONTACT_USER_ID = "COMMENT_FROM_CONTACT";
export const PERSONAL_EXPENSE_MEMO = "Repayment for Personal Expense";
